module.exports = __webpack_public_path__ + "img/logo.5346efdb.png";